<template>
	<div>
		<form class="form-container" @submit.prevent="sendInquiry">
			<h5 class="bold">{{ $t('inquiryForm0') }} - {{productDetails.product_name}}</h5>
			<br/>
			<p>{{ $t('hello') }} {{productDetails.client_name}},</p>
			<br/>
			<p>{{ $t('inquiryForm1') }} {{productDetails.product_name}}.</p>
			<p>{{ $t('inquiryForm2') }}</p>
			<label>{{ $t('inquiryQty') }} (MOQ = {{productDetails.moq}} {{ $t('inquiryForm4') }})</label>
			<input 
				v-model="inquirer.quantity" 
				type="number"
				:min="productDetails.moq"
				:class="{ error: $v.inquirer.quantity.$error }"
				@blur="$v.inquirer.quantity.$touch()"
			/>
			<template v-if="$v.inquirer.quantity.$error">
				<p v-if="!$v.inquirer.quantity.required" class="errorMessage">
				{{ $t('inquiryQtyReq') }}
				</p>
				<p v-if="!$v.inquirer.quantity.minValue" class="errorMessage">
				{{ $t('minQtyReq') }}{{productDetails.moq}}
				</p>
			</template>
			<label>{{ $t('inquirerMessage') }}</label>
			<textarea  
				v-model="inquirer.message" 
				type="text"
				id="note"
				class="InquirerMessage"
				maxlength="250"
			/>
			<label>{{ $t('inquiryForm3') }}:</label>
			<p>{{clientDetails.name}}, {{clientDetails.address}}, {{clientDetails.contact_no}}, {{clientDetails.vat_no}}</p>
			<p>{{ $t('inquiryForm5') }}: <label class="bold">{{inquireDetails.email}}</label></p>
			<p>{{ $t('bestRegards') }}</p>
			<br/>
			<button :disabled="$v.$invalid" class="add-btn" type="submit" name="button">
					{{ $t('sendMail') }}
			</button>
		</form>			
    	<p>{{ $t('inquiryForm6') }}</p>
		<p>{{productDetails.client_company_name}}, {{productDetails.client_address}}, {{productDetails.client_postal_code}}, {{productDetails.client_city}}, {{productDetails.client_country}}</p>
		<p>{{productDetails.client_contact_no}}</p>
	</div>
</template>

<script>
// import NProgress from 'nprogress'
import { required, minValue } from 'vuelidate/lib/validators'
let minQuantity = 0

export default {
	data() {
		return {
			errors: null,
			inquirer: {
				quantity: '',
				message : ''
			}
		}
	},
	validations() {
		return {
			inquirer: {
				quantity : { required, minValue: minValue(minQuantity) },
			}
		}
	},
	created() {
		minQuantity = this.productDetails.moq
	},
	methods: {
		async sendInquiry() {
			const inquiryData = {
				email: this.productDetails.client_email,
				inquirer_name: this.clientDetails.name,
				inquirer_quantity: this.inquirer.quantity,
				inquirer_message: this.inquirer.message,
				client_name: this.productDetails.client_name,
				product_name: this.productDetails.product_name,
				inquirer_company_name: this.clientDetails.name,
                inquirer_company_address: this.clientDetails.address,
                inquirer_company_email: this.inquireDetails.email,
                inquirer_company_contact_no: this.clientDetails.contact_no
			}
			try {
				await this.$store.dispatch('marketPlace/sendInquiry', inquiryData)
				this.$emit('hide-product-inquiry-form', null)
			} catch (error) {
				alert(this.$t('inquirySentFailure'))
				this.$emit('hide-product-inquiry-form', null)
			}
		}
	},
	props: {
		productDetails: {
			type: Object,
			default: () => {
				return {}
			}
		},
		clientDetails: {
			type: Object,
			default: () => {
				return {}
			}
		},
		inquireDetails: {
			type: Object,
			default: () => {
				return {}
			}
		}
	}
}
</script>

<style lang="scss" scoped>

.optionalData {
	background-color: var(--grey-light);
	border: 1px solid var(--grey);
	padding: 0 20px;
	width: 100%;
}
.optional {
	text-align: center;
	letter-spacing: 5px;
	color: var(--bg);
}
.form-container {
	//position: absolute;
	background: #fff;
	color: var(--bg) !important;
	padding: 30px;
	border-radius: 10px;
	box-shadow: 0px 0px 8px 0px #000;
	width: auto;
}

.form-container p {
	color: var(--bg) !important;
}

.InquirerMessage {
	height:200px;
}

form .selectCountry {
	text-align: left;
	margin-bottom: 0px;
	color: #747474;
	width: 100%;
	margin-top: 10px;
	padding-left: 5px;
}
p {
	margin-top: -15px;
}

.bold {
	font-weight: 800;
}

.inputStyle {
	margin-bottom: 24px;
	width: 100%;
	display: block;
	height: calc(1.5em + .75rem + 2px);
	padding: .375rem .75rem;
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid #ced4da;
	border-radius: .25rem;
	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.field {
	margin-bottom: 24px;
}

a:visited {
	color: #2c3e50;
}

.button,
button {
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 5px;
	background: linear-gradient(to right, $secondary, $secondary-dark);
	font-size: 1.5em;
	color: white;
	border: none;
	text-transform: uppercase;
	letter-spacing: 0.15em;
	outline: none;
	margin: auto;
}

button:disabled,
button[disabled]{
	border: 1px solid #999999;
	background-color: #cccccc;
	color: #666666;
	cursor: context-menu;
}

form {
	display: flex;
	text-align: left;
	flex-direction: column;

	p {
		color: red;
	}
}

input {
	display: block;
	box-sizing: border-box;
	background-clip: padding-box;
	border: 1px solid #ced4da;
	border-radius: .25rem;
	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
	width: 100%;
	height: 2.6em;
	padding: 0.5em;
	margin-bottom: 1em;
	font: 1em 'Lato', Helvetica, sans-serif;
}

textarea {
	display: block;
	box-sizing: border-box;
	background-clip: padding-box;
	border: 1px solid #ced4da;
	border-radius: .25rem;
	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
	font: 1em 'Lato', Helvetica, sans-serif;
}

.bgOptional {
	background: rgb(252, 250, 250);
}

h1 {
	margin-top: 0;
}

.add-btn {
	background: var(--primaryDark);
	border-radius: 5px;
	color: var(--bright);
	padding: 0.3em;
	letter-spacing: 3px;
	width: 80%;
}

.errorMessage {
	font-size: 0.8em;
	margin-top: -10px;
	color: var(--primaryDark);
}

@media screen and (max-width: 560px){
.optionalData {
    padding: 10px;
	}
}
</style>
